import IowResponseRows from '@/components/grid/api/iow/response/IowResponseRows';

export default class IowRowValidator {
    validate(row: IowResponseRows, groups: string[]): boolean {
        return Boolean(row.data.length);
    }
}
